"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadeColor = exports.hexToRgb = void 0;
var tinycolor2_1 = __importDefault(require("tinycolor2"));
var TypeGuards = __importStar(require("./typeGuards"));
function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : null;
}
exports.hexToRgb = hexToRgb;
var shadeColorCache = {};
function shadeColor(color, percent, opacity) {
    if (percent === void 0) { percent = 0; }
    if (opacity === void 0) { opacity = null; }
    var _color = color.trim();
    var serialParams = [_color, percent.toString()];
    if (TypeGuards.isNumber(opacity)) {
        serialParams.push(opacity.toString());
    }
    var cacheKey = serialParams.join('/');
    if (!!shadeColorCache[cacheKey]) {
        return shadeColorCache[cacheKey];
    }
    var cl = (0, tinycolor2_1.default)(_color);
    if (percent !== 0) {
        var shouldDarken = percent < 0;
        if (shouldDarken) {
            cl.darken(-percent);
        }
        else {
            cl.lighten(percent);
        }
    }
    if (TypeGuards.isNumber(opacity)) {
        cl.setAlpha(opacity);
    }
    var rgbObj = cl.toRgb();
    var rgbStr = "rgba(".concat(rgbObj.r, ",").concat(rgbObj.g, ",").concat(rgbObj.b, ",").concat(rgbObj.a, ")");
    shadeColorCache[cacheKey] = rgbStr;
    return rgbStr;
}
exports.shadeColor = shadeColor;
